export default {
  about_me: 'About me',
  relationships: 'Relationship',
  requirements: 'Requirements',
  users: 'Users',
  sign_up: 'Sign Up',
  footer: 'Footer',
  sign_out: 'Sign Out',
  test_assignment: 'Test assignment for Frontend Developer position',
  kindly_remind: 'We kindly remind you that your test assignment should be submitted as a link to github/bitbucket repository. Please be patient, we consider and respond to every application that meets minimum Requirements. We look forward to your submission. Good luck!',
  acquainted: 'Let\'s get acquainted',
  developer: 'I am cool frontend developer',
  slow_experience: 'When real users have a slow experience on mobile, they\'re much less likely to find what they are looking for or purchase from you in the future. For many sites this equates to a huge missed opportunity, especially when more than half of visits are abandoned if a mobile page takes over 3 seconds to load.',
  improve: 'Last week, Google Search and Ads teams announced two new speed initiatives to help improve user-experience on the web.',
  me_and_web: 'About my relationships with web-development',
  love_html: 'I\'m in love with HTML',
  html: 'Hypertext Markup Language (HTML) is the standard markup language for creating web pages and web applications.',
  friend_css: 'CSS is my best friend',
  css: 'Cascading Style Sheets (CSS) is a style sheet language used for describing the presentation of a document written in a markup language like HTML.',
  passion_js: 'JavaScript is my passion',
  js: 'JavaScript is a high-level, interpreted programming language. It is a language which is also characterized as dynamic, weakly typed, prototype-based and multi-paradigm.',
  requirements_desc: 'General Requirements for the test task',
  speed: 'Users want to find answers to their questions quickly and data shows that people really care about how quickly their pages load. The Search team announced speed would be a ranking signal for desktop searches in 2010 and as of this month (July 2018), page speed will be a ranking factor for mobile searches too.',
  performance: 'If you\'re a developer working on a site, now is a good time to evaluate your performance using our speed tools. Think about how performance affects the user experience of your pages and consider measuring a variety of real-world user-centric performance metrics.',
  images: 'Are you shipping too much JavaScript? Too many images? Images and JavaScript are the most significant contributors to the page weight that affect page load time based on data from HTTP Archive and the Chrome User Experience Report - our public dataset for key UX metrics as experienced by Chrome users under real-world conditions.',
  users_block: 'Our cheerful users',
  registration_date: 'Attention! Sorting users by registration date',
  more_users: 'Show more',
  nameLabel: 'Name',
  emailLabel: 'Email',
  phoneLabel: 'Phone',
  namePlaceholder: 'Your name',
  emailPlaceholder: 'Your email',
  phonePlaceholder: 'Your phone',
  uploadLabel: 'Upload',
  uploadPlaceholder: 'Upload photo',
  enter_fields: 'If you want to Register a new user you have to enter all fields',
  successfully_registered: 'New user successfully registered',
  registered_with_error: 'Error: Network Error',
  select_position :'Select your position',
  lawyer_position: 'Lawyer',
  content_manager_position: 'Content manager',
  security_position: 'Security',
  designer_position: 'Designer',
  register_title: 'Register to get a work',
  update_userslist: 'Attention! After successful registration and alert, update the list of users in the block from the top',
  footer_center_links_news: 'News',
  footer_center_links_blog: 'Blog',
  footer_center_links_partners: 'Partners',
  footer_center_links_shop: 'Shop',
  footer_center_links_overview: 'Overview',
  footer_center_links_design: 'Design',
  footer_center_links_code: 'Code',
  footer_center_links_collaborate: 'Collaborate',
  footer_center_links_tutorials: 'Tutorials',
  footer_center_links_resources: 'Resources',
  footer_center_links_guides: 'Guides',
  footer_center_links_examples: 'Examples',
  footer_center_links_faq: 'FAQ',
  footer_center_links_terms: 'Terms',
  footer_center_links_conditions: 'Conditions',
  footer_center_links_help: 'Help',
  write_name_error: 'You must enter your name',
  name_size: 'Name must include from 2 to 60 letters',
  write_email_error: 'You must enter your email',
  no_correct_email: 'Enter correct email',
  write_phone_error: 'You must enter your phone number',
  no_correct_phone: 'Enter phone number in +380XXXXXXXXX',
  photo_type_error: 'The photo must have jpeg or jpg format',
  no_correct_size: 'The size of photo must be less than 5 MB',
  no_correct_width_height: 'The size of photo must be no less than 70 * 70',
  select_error: 'You must select your position'
}